// Customer-portal backend: serves the TIA, Laser, Strategic Plan, Decision Debt
// and RBAC-config APIs this app calls, and accepts the Flameco Authentication
// Service token. REACT_APP_BACKEND_URL overrides it (e.g. a local backend).
export const FLAMECO_AUTH_BASE_URL =
  (process.env.REACT_APP_BACKEND_URL || '').trim().replace(/\/+$/, '') ||
  'https://customer-portal-backend-engwe5fya7ckajat.centralus-01.azurewebsites.net';

// Flameco Authentication Service: the only way to sign in to this app.
export const FLAMECO_AUTH_URL =
  (process.env.REACT_APP_FLAMECO_AUTH_URL || '').trim() || 'https://auth.flameco.com';
// This app's client id, as registered by flameco-auth.json.
export const FLAMECO_CLIENT_ID =
  (process.env.REACT_APP_FLAMECO_CLIENT_ID || '').trim() || 'internal-tools';
